export function caseStudySliders() {
    let $infoSlider = $(".info-slider");
    let $navContainer = $(".case-study-section .info-slider-nav");
    let $cards = $(".media-slider-item");

    $($cards[0]).addClass("active");

    $infoSlider.slick({
        asNavFor: $navContainer,
        slidesToShow: 1,
        slidesToSlide: 1,
        infinite: true,
        draggable: false,
        arrows: false,
        fade: true,
    });

    $navContainer.slick({
        slidesToShow: 4,
        slidesToSlide: 1,
        dots: false,
        arrows: true,
        speed: 300,
        focusOnSelect: true,
        pauseOnFocus: false,
        pauseOnHover: false,
        autoplay: true,
        autoplaySpeed: 7000,
        asNavFor: $infoSlider,
        nextArrow: `<button class="next" title="next button"><svg width="21" height="18" viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 9H19M19 9L10.6875 1M19 9L10.6875 17" stroke="#221C35" stroke-width="2"/>
                    </svg></button>`,
        prevArrow: `<button class="prev" title="prev button"><svg width="21" height="18" viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 9H19M19 9L10.6875 1M19 9L10.6875 17" stroke="#221C35" stroke-width="2"/>
                    </svg></button>`,
    }).on("beforeChange", function (event, slick, currentSlide, nextSlide) {

        if (currentSlide === nextSlide) {
            return;
        }

        if (nextSlide === $cards.length - 1) {

            $($cards[0]).addClass("penultimate");
        } else if ($($cards[0]).hasClass("penultimate")) {

            $($cards[0]).removeClass("penultimate");
        }

        $($cards[nextSlide]).addClass("active");

        if (nextSlide > currentSlide || nextSlide === 0 && currentSlide === $cards.length - 1) {
            $($cards[currentSlide]).addClass("ex-active");

            setTimeout(() => {
                $($cards[currentSlide]).removeClass("active");
            }, 150);

            setTimeout(() => {
                $($cards[currentSlide]).removeClass("ex-active");
            }, 700);
        } else {

            setTimeout(() => {
                $($cards[currentSlide]).removeClass("active");
            }, 150);
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/caseStudySliders.js